// material-ui
import { Theme } from "@mui/material/styles";

// ==============================|| OVERRIDES - LIST ITEM ICON ||============================== //

export default function ListItemButton(theme: Theme) {
  return {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          "&.Mui-selected": {
            color: theme.palette.primary.main,
            ...theme.applyStyles("dark", {
              color: theme.palette.primary.darker,
            }),
            "& .MuiListItemIcon-root": {
              color: theme.palette.primary.main,
            },
          },
        },
      },
    },
  };
}
